"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initReport = void 0;
function initReport() {
    const { wetvReport } = window;
    if (!wetvReport) {
        setTimeout(initReport, 3000);
        return null;
    }
    wetvReport({
        warpSuccessFn: listenPage,
    });
}
exports.initReport = initReport;
function listenPage() {
    const pgid = 'p_download';
    const { wetvReportInstance } = window;
    wetvReportInstance
        .setPage({
        pgid,
    }, document.body)
        .observe(pgid);
    // wetvReportInstance?.switchPage?.();
}
